import React from 'react';

import { Control } from 'react-hook-form';

import ConditionalWrapper from 'components/ConditionalWrapper';
import UseFormControlWrapper from 'components/UseFormControllWrapper';

import styles from './Select.module.scss';
import SelectBase, { InputSelectProps } from './SelectBase';

interface ControlledSelectProps extends React.PropsWithChildren<{}>, InputSelectProps {
  name: string;
  useFormControl?: boolean;
  required?: boolean;
  control?: Control<any>;
  label?: string;
  errorMessageReferenceName?: string;
  caption?: string;
}

const Select = ({
  useFormControl,
  required,
  name,
  control,
  label,
  errorMessageReferenceName,
  caption,
  ...rest
}: ControlledSelectProps) => {
  return (
    <>
      <ConditionalWrapper
        condition={useFormControl}
        wrapper={(children) => (
          <UseFormControlWrapper
            name={name}
            control={control}
            required={required}
            label={label}
            errorMessageReferenceName={errorMessageReferenceName}
          >
            {children}
          </UseFormControlWrapper>
        )}
      >
        <SelectBase label={label} {...rest} />
      </ConditionalWrapper>
      {caption && <p className={styles.caption}>{caption}</p>}
    </>
  );
};

export default Select;
